import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useAuth } from "../core/AuthContextProvider";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const { forgotpassword } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [toasting, setToasting] = useState(false);

  async function onSubmit(data) {
    try {
      await forgotpassword(data.email);
      toast.success(`An email has been send for password reset instructions.`, {
        toastId: "reset_email",
        onClose: () => {
          setToasting(false);
        },
        onOpen: () => {
          setToasting(true);
        },
      });
    } catch (error) {
      toast.error(
        `Problem in sending mail to ${data.email} . Please try again later.`
      );
    }
  }

  return (
    <div className="bg-image">
      <div className="flex items-center h-screen">
        <div className="bg-white p-7 rounded-md w-[500px] mx-auto">
          <div>
            <Link to="/" className="p-4 flex justify-center">
              <img
                alt="cleancooler"
                className="w-30 h-20"
                src="./images/Fit-Fresh-Logo.png"
              />
            </Link>
          </div>
          <h2 className="font-bold text-2xl xl:text-3xl text-center xl:text-left">
            Forgot Your Password?
          </h2>
          {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* register your input into the hook by invoking the "register" function */}
            <div className="intro-x mt-8">
              <input
                className="form-control w-full border rounded-md shadow-md py-4 px-5 border border-black-300 mb-5 outline-none"
                placeholder="Email"
                {...register("email", {
                  required: true,
                  pattern: {
                    value: /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  },
                })}
              />
              {errors.email && (
                <span className="text-red-600">Enter a Valid Email-ID</span>
              )}
              {/* include validation with required or other standard HTML validation rules */}
            </div>

            <div className="flex items-center text-gray-700 justify-between dark:text-gray-600 text-xs sm:text-sm mt-6">
              <div className="button">
                <input
                  disabled={toasting}
                  type="submit"
                  className="w-36 px-6 py-3 text-lg cursor-pointer text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#024C85] hover:bg-yellow-500 hover:shadow-lg focus:outline-none"
                />
              </div>
              <div>
                <Link
                  to="/"
                  className="text-[#024C85] underline hover:no-underline ml-3"
                >
                  Already have an account? Login!
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
